<script lang="ts">
	import { Headline } from '@repo/ui'

	interface Props {
		headline: string
		description?: string
		children?: import('svelte').Snippet
	}

	let { headline, description = '', children }: Props = $props()
</script>

<Headline>
	{headline}
</Headline>

<div class="mt-2 text-gray-600 dark:text-gray-200">
	{#if children}{@render children()}{:else}
		{description}
	{/if}
</div>

<div class="mt-11"></div>
